// components/SheetsTable/useStyledColumns.js
import { useMemo } from "react";
import { Box } from "@mui/material";
import ActionCell from "./ActionCell";

export const useStyledColumns = (columns, actions, hasAnyAction) =>
  useMemo(() => {
    const baseColumns = [...columns];

    // 🔥 só cria a coluna se houver ao menos 1 ação visível
    if (hasAnyAction) {
      baseColumns.push({
        field: "actions",
        headerName: "Ações",
        width: 80,
        sortable: false,
        filterable: false,
        disableColumnMenu: true,
        disableReorder: true,
        renderCell: (params) => (
          <ActionCell params={params} actions={actions} />
        ),
      });
    }

    return baseColumns.map((col) => {
      const isCompact = col.isCompact === true;
      const originalRender = col.renderCell;

      return {
        ...col,

        disableColumnMenu: col.disableColumnMenu ?? isCompact,
        filterable: col.filterable ?? !isCompact,
        sortable: col.sortable ?? !isCompact,

        renderCell: isCompact
          ? (params) => (
              <Box
                sx={{
                  height: "100%", 
                  width: "100%",
                  display: "flex",
                  alignItems: "center",  
                  justifyContent: "center",  
                }}
              >
                {originalRender ? originalRender(params) : params.value}
              </Box>
            )
          : originalRender,
      };
    });
  }, [columns, actions, hasAnyAction]);
